// src/components/views/SchoolView.js
import React, { useState } from 'react';
import SchoolStats from '../SchoolStats';
import SchoolDetails from '../SchoolDetails';
import SurveyModal from '../SurveyModal';

const SchoolView = ({ allData, filters, updateFilters, onBack, onLoadSurveyData }) => {
  const { school: schoolId } = filters;
  const school = allData.dates.find(item => item.Код.toString() === schoolId.toString());
  const schoolSurveyData = allData.survey.schools[schoolId];
  const [showSurveyModal, setShowSurveyModal] = useState(false);
  const [surveyLoading, setSurveyLoading] = useState(false);
  
  const handleShowSurvey = async () => {
    if (school) {
      setSurveyLoading(true);
      await onLoadSurveyData('school', schoolId, school.Наименование, [schoolId]);
      setSurveyLoading(false);
      setShowSurveyModal(true);
    }
  };

  if (!school) {
    return (
      <div id="school-view" className="view">
        <button className="back-button" onClick={onBack}>← Назад</button>
        <div className="level-indicator">ОУ</div>
        <div className="no-data">ОУ не найдено</div>
      </div>
    );
  }

  const schoolData = filterDataBySchool(schoolId, allData);

  return (
    <div id="school-view" className="view">
      <button className="back-button" onClick={onBack}>← Назад</button>
      <div className="level-indicator">ОУ</div>
      <h2 className="view-title">{school.Наименование}</h2>
      
      <SchoolStats school={school} schoolData={schoolData} filters={filters} />
      
      

      {showSurveyModal && (
        <SurveyModal
          surveyData={schoolSurveyData}
          entityName={school.Наименование}
          level="school"
          onClose={() => setShowSurveyModal(false)}
        />
      )}
      
      <SchoolDetails school={school} schoolData={schoolData} filters={filters} />
    </div>
  );
};

const filterDataBySchool = (schoolId, data) => {
  const school = data.dates.find(item => item.Код.toString() === schoolId.toString());
  if (!school) return { dates: [], errors: [], publication: [], compliance: [], timeliness: [] };
  
  return {
    dates: [school],
    errors: data.errors.filter(item => item.Пищеблок.includes(school.Наименование)),
    publication: data.publication.filter(item => item.Код.toString() === schoolId.toString()),
    compliance: data.compliance.filter(item => item.ПищеблокНаименование.includes(school.Наименование)),
    timeliness: data.timeliness.filter(item => item.Пищеблок === school.Наименование)
  };
};

export default SchoolView;